import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getCanonicalUrl, getStructuredData, landingSeo } from '../config/landingSeo';

export default function LandingSeoHead() {
  const {
    title,
    description,
    keywords,
    siteName,
    brandName,
    locale,
    ogImage,
    ogImageAlt,
    ogType,
    twitterCard,
    author,
    robots,
    siteUrl,
  } = landingSeo;

  const canonicalUrl = getCanonicalUrl('/');
  const structuredData = getStructuredData();

  return (
    <Helmet>
      <html lang="fa" dir="rtl" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
      <meta name="language" content="Persian" />
      <meta name="content-language" content="fa" />
      <meta name="geo.region" content="IR" />
      <meta name="application-name" content={siteName} />
      <meta name="apple-mobile-web-app-title" content={siteName} />
      <meta name="theme-color" content="#020617" />

      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:locale" content={locale} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={ogImageAlt} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={ogImageAlt} />

      <meta name="twitter:site" content={`@${brandName}`} />

      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>

      {/* fallback for crawlers that read initial HTML before hydration */}
      <meta name="coresell:site-url" content={siteUrl} />
    </Helmet>
  );
}
